import { gql } from "@apollo/client";

import IOperation from "api/IOperation";
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { BeginOrderPlacementMutation as BeginOrderPlacementMutationType, BeginOrderPlacementMutationVariables } from "gql/types/mutations/BeginOrderPlacementMutation";

const text = gql`mutation BeginOrderPlacementMutation($beginOrderPlacementInput: MutationBeginOrderPlacementInput!) {
	beginOrderPlacement(beginOrderPlacementInput: $beginOrderPlacementInput) {
		order {
			id
		}
		paymentIntentKey
	}
}
`;

const BeginOrderPlacementMutation: IOperation<BeginOrderPlacementMutationType, BeginOrderPlacementMutationVariables> = { text } as any;

export default BeginOrderPlacementMutation;
